import { Card, CardHeader, CardTitle, CardContent } from '@/components/ui/card';
import { formatDateWithYear } from '@/utils/dateFormatters';
import BreadcrumbComponent from '@/components/BreadcrumbComponent';
import { Coins, Star } from 'lucide-react';
import CardSkeleton from '@/components/CardSkeleton';
import { useBonuses } from '@/hooks/useBonuses';
import { Typography } from '@/components/ui/typography';

const Bonuses = () => {
  const { bonusesData, isLoading } = useBonuses();

  return (
    <div className="flex flex-col p-3 w-full">
      <BreadcrumbComponent link={'Бонусный счет'} />
      <div className="mb-6 flex items-center gap-2">
        <Star className="h-5 w-5 text-primary" />
        <h2 className="text-xl font-medium text-gray-900">Бонусный счет</h2>
      </div>
      <div className="grid gap-4 m:grid-cols-1">
        {isLoading
          ? [...Array(1)].map((_, index) => <CardSkeleton key={index} />)
          : bonusesData &&
            bonusesData.map(
              (bonuses, index) =>
                (index === 0 || bonuses.balance > 0) && (
                  <Card key={bonuses.id} className="overflow-hidden transition-all hover:shadow-lg">
                    <CardHeader className="border-b bg-gradient-to-r from-primary/5 to-primary/10 p-4">
                      <div className="flex flex-col gap-2">
                        <div className="group flex items-center gap-3">
                          <div className="rounded-full bg-primary/10 p-2 sm:p-2">
                            <Coins className="h-5 w-5 text-primary" />
                          </div>
                          <Typography
                            variant="h3"
                            className="min-w-[40rem] md:min-w-[20rem] font-normal text-lg font-normal text-gray-800 group-hover:text-primary transition-colors">
                            {bonuses.name}
                          </Typography>
                        </div>
                      </div>
                    </CardHeader>
                    <CardContent className="space-y-4 p-4">
                      <div className="flex flex-col gap-3">
                        <div className="flex items-center justify-between text-sm">
                          <span className="text-muted-foreground">Баланс: </span>
                          <Typography variant="p" className="text-base leading-relaxed">
                            {bonuses.balance}
                          </Typography>
                        </div>
                        {/* Сроки действия бонусов(временно скрыли)
                    <div className="flex items-center justify-between text-sm">
                      <span className="text-muted-foreground">Сроки действия: </span>
                      <Typography variant="p" className="text-base leading-relaxed">
                        {formatDateWithYear(bonuses.accrual_validity_period)}
                      </Typography>
                    </div> */}
                      </div>
                    </CardContent>
                  </Card>
                ),
            )}
      </div>
    </div>
  );
};

export default Bonuses;
